import { render, staticRenderFns } from "./Template3.vue?vue&type=template&id=fe62fd10&scoped=true&"
import script from "./Template3.vue?vue&type=script&lang=js&"
export * from "./Template3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe62fd10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe62fd10')) {
      api.createRecord('fe62fd10', component.options)
    } else {
      api.reload('fe62fd10', component.options)
    }
    module.hot.accept("./Template3.vue?vue&type=template&id=fe62fd10&scoped=true&", function () {
      api.rerender('fe62fd10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/JVxeDemo/layout-demo/Template3.vue"
export default component.exports